import { styled } from 'styled-components';

export const Text = styled.span`
  width: 350px;
  color: #000;
  text-align: center;
  font-feature-settings: 'case' on;
  font-family: 'Poppins-Regular';

  font-size: 20px;

  line-height: 30px; /* 150% */
  letter-spacing: -0.408px;
`;

export const InputWrapper = styled.div`
  width: 353px;
`;

export const QuestionWrapper = styled.div`
  display: flex;
  width: 361px;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  border: 1px solid #dccbc5;
  background: #fffdfc;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  @media (max-width: 540px) {
    width: 100%;
  }
`;

export const Quest = styled.span`
  font-family: 'Poppins-Regular';

  font-size: 14px;

  letter-spacing: -0.2px;
`;

export const Or = styled.span`
  font-family: 'Poppins-Regular';

  text-align: center;

  font-size: 12px;

  line-height: 38px; /* 316.667% */
  letter-spacing: -0.2px;
  opacity: 0.5;

  justify-content: center;
  display: flex;
  text-transform: uppercase;
`;

export const CheckboxContainer = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 540px) {
    width: 100%;
  }
`;
export const QuestContainer = styled(CheckboxContainer)`
  align-items: flex-start;
  width: 100%;
  gap: 8px;
`;
export const StyledText = styled.span`
  color: #000;
  text-align: center;
  font-family: Playfair Display;
  font-size: 33px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const QuestionAttending = styled.span`
  color: #000;
  text-align: center;
  font-family: 'Poppins-Medium';

  font-size: 16px;
  font-style: normal;

  line-height: normal;
  letter-spacing: -0.408px;
`;

export const NameEditContainer = styled.div`
  gap: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const InputNameContainer = styled.div`
  /* gap: 20px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 30px;
  padding-bottom: 20px;
`;

export const NameInput = styled.input`
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  background-color: white;
  //border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }
  &::placeholder {
    color: #000;
  }
  &:not(:disabled) {
    outline: none;
    border-bottom: 1px solid #000;
  }
  color: #000;
  text-align: center;
  font-family: Playfair Display;
  font-size: 33px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
